import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e5e0b40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex some-inputs" }
const _hoisted_4 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название магазина*", -1))
const _hoisted_6 = { class: "flex flex-col input-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Короткое название", -1))
const _hoisted_8 = { class: "flex some-inputs m-t-8" }
const _hoisted_9 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "ИНН*", -1))
const _hoisted_11 = { class: "flex flex-col input-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Хэш ИНН", -1))
const _hoisted_13 = { class: "form-block" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Категория*", -1))
const _hoisted_16 = { class: "toggle-row m-t-8" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "has_data_from_providers",
  class: "small-label"
}, "Поступают данные от провайдеров", -1))

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useShopsStore } from "@/store/dictionaries/shops";

import InputText from "primevue/inputtext";
import { areShopFieldsValid } from "@/services/dictionaries/shops";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import ImportantChangesDialog from "@/shared/dialogs/ImportantChangesDialog.vue";

import { rootGetters } from "@/main";
import { useCategoriesStore } from "@/store/catalog_data/categories";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useShopsStore();
const categoriesStore = useCategoriesStore();

const shop = ref({
  shop_name: "",
  shop_short_name: "",
  shop_pk: "",
  shop_inn: "",
  category_id: 0,
  has_data_from_providers: false,
});

const isInvalidForm = ref(false);
const isShopSetted = computed(() => {
  return Boolean(route.params.id);
});
const isLoadingData = ref(false);
const isLoadingDataCategories = ref(false);
const confirmVisible = ref(false);
const catsList = ref([]);

const reload = () => {
  isLoadingDataCategories.value = true;
  categoriesStore.getC1Categories().then((cats) => {
    catsList.value = cats;
    isLoadingDataCategories.value = false;
  });
  if (isShopSetted.value) {
    const shopId = parseInt(route.params.id);
    isLoadingData.value = true;
    store
      .getShop(shopId)
      .then((shopClone) => {
        if (shopClone) {
          shop.value.shop_name = shopClone.shop_name;
          shop.value.shop_short_name = shopClone.short_name;
          shop.value.shop_inn = shopClone.shop_inn;
          shop.value.shop_pk = shopClone.shop_pk;
          shop.value.category_id = shopClone.category_id;
          shop.value.has_data_from_providers =
            shopClone.has_data_from_providers ?? false;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const createShop = () => {
  if (!areShopFieldsValid(shop.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`,
    );
    return;
  }

  const shopCopy = { ...shop.value };
  if (shop.value.shop_pk == "") {
    delete (shopCopy as any).shop_pk;
  }
  if (!isShopSetted.value) {
    performShopAction(() => store.createShop(shopCopy));
  } else {
    confirmVisible.value = true;
  }
};

const editShop = () => {
  confirmVisible.value = false;
  const shopCopy = { ...shop.value };
  if (shop.value.shop_pk == "") {
    delete (shopCopy as any).shop_pk;
  }
  performShopAction(() =>
    store.updateShop(shopCopy, parseInt(route.params.id)),
  );
};

const performShopAction = (action: any) => {
  emit("setLoading", true);
  const handleSuccess = () => {
    router.push({ name: "shops" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

__expose({
  createShop,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: shop.value.shop_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shop.value.shop_name) = $event)),
                disabled: false,
                invalid: isInvalidForm.value && shop.value.shop_name == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: shop.value.shop_short_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shop.value.shop_short_name) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: shop.value.shop_inn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shop.value.shop_inn) = $event)),
                disabled: false,
                invalid: isInvalidForm.value && shop.value.shop_inn == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: shop.value.shop_pk,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shop.value.shop_pk) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dropdown), {
              loading: isLoadingDataCategories.value,
              modelValue: shop.value.category_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shop.value.category_id) = $event)),
              optionLabel: "name",
              "option-value": "id",
              options: catsList.value,
              invalid: isInvalidForm.value && shop.value.category_id == 0,
              placeholder: "Выберите значение",
              filter: ""
            }, null, 8, ["loading", "modelValue", "options", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputSwitch), {
              modelValue: shop.value.has_data_from_providers,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shop.value.has_data_from_providers) = $event)),
              inputId: "has_data_from_providers"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ])
    ]),
    _createVNode(ImportantChangesDialog, {
      "object-name": "магазин",
      visible: confirmVisible.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (confirmVisible.value = false)),
      onEdit: editShop
    }, null, 8, ["visible"])
  ]))
}
}

})